import clsx from 'clsx';
import { useId } from 'react';

import styles from '@/app/cc/_component/ui/common/Tab/Tab.module.scss';

interface TabProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  color?: 'gray' | 'dark' | 'primary' | 'white';
  variant?: 'fill' | 'line';
  active?: 'fill_primary' | 'fill_dark' | 'fill_gray' | 'line_primary' | 'line_dark' | 'line_gray' | 'line_secondary'; // active 클래스가 상황에 따라 다양할 수 있음
  name: string;
  id?: string;
  value: string;
  onChange: () => void;
  children: React.ReactNode;
}

export default function Tab({
  className,
  size = 'sm',
  color = 'primary',
  variant = 'fill',
  active,
  name,
  id: externalId,
  value,
  children,
  disabled,
  checked,
  onChange,
  ...props
}: Readonly<TabProps>) {
  const reactId = useId();
  const generatedId = `tab-${reactId}`;
  const id = externalId ?? generatedId;

  return (
    <label
      htmlFor={id}
      className={clsx(
        styles.tab,
        styles[size],
        styles[variant],
        // 체크되지 않았을 때만 기본 컬러 스타일 적용
        !checked && styles[color],
        // 체크되었을 때 사용자가 지정한 active 클래스 적용
        checked && active && styles[active],
        className,
      )}
    >
      <input
        type="radio"
        name={name}
        id={id}
        value={value}
        disabled={disabled}
        checked={checked}
        onChange={onChange}
        {...props}
      />
      {children}
    </label>
  );
}
